const VacationInitialText ="This is your opportunity to take a long break from the day-to-day " +
    "routine. Several options are displayed below that will be interesting and fun.  Choose  " +
    "the one that sounds best."
        
export default VacationInitialText 
 